//@ts-check
import { useEffect, useCallback, useRef } from "react";
/**
 * Simple tracking of mounted state
 */
export default function useMounted() {
  var fn = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : undefined;
  var mounted = useRef(false);
  useEffect(function () {
    mounted.current = true;
    return function () {
      mounted.current = false;
    };
  }, []);
  var cb = useCallback(function () {
    return mounted.current && fn.apply(void 0, arguments);
  }, [fn]);
  return fn ? cb : mounted;
}
//# sourceMappingURL=useMounted.js.map